var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentPersonContactsFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.818 5A1.818 1.818 0 002 6.818v10.91c0 1.003.814 1.817 1.818 1.817h16.364A1.818 1.818 0 0022 17.727V6.818A1.818 1.818 0 0020.182 5H3.818zm4.091 7.273a1.59 1.59 0 10.001-3.181 1.59 1.59 0 000 3.18zm0 .795c-1.062 0-3.182.533-3.182 1.591v.795h6.364v-.795c0-1.058-2.12-1.59-3.182-1.59zM19.273 10h-5.455v1.364h5.455V10zm0 3.182h-5.455v1.363h5.455v-1.363z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPersonContactsFill);
export default __webpack_public_path__ + "3f6d99398e9905ca8d66ea499402cd2c.svg";
export { ForwardRef as ReactComponent };